import React from 'react';
import { Layout, Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import './Footer.css';

const { Footer: AntFooter } = Layout;

const Footer = () => {
  const handleZaloClick = () => {
    // Replace this Zalo link with your own Zalo link
    window.open('https://zalo.me/your-zalo-id', '_blank');
  };

  return (
    <AntFooter className="app-footer">
      <div className="footer-content">
        <div className="footer-info">
          <p>&copy; 2025 Voice Synthesis - Developed by @huyit32</p>
        </div>
        <div className="footer-contact">
          <Button 
            type="primary" 
            icon={<MessageOutlined />}
            onClick={handleZaloClick}
            className="zalo-button"
          >
            Contact via Zalo
          </Button>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;